/* global G */

import { getFirstItem, setKey } from 'lib/util'

/**
 * Initializes the settings adapter by dispatching `G.SETTINGS, G.INIT` if the user's
 * role has permissions to have user settings.
 *
 * @param {Gaia.Web.Application|Gaia.AppModule.Spec} obj the platform Application
 * @returns {function(*): Promise<*>}
 */
const init = obj => async (args) => {
  const sessionState = obj?.[G.SESSION]?.[G.STATE] || obj[G.ADAPTER]?.[G.SESSION]?.[G.STATE]
  const meta = sessionState?.[G.META]
  const currentContext = sessionState?.[G.CONTEXT]

  if (meta?.refs && meta.refs?.user?.length) { // user is logged in
    const userSettings = getFirstItem(meta?.refs?.settings)

    try {
      // the server needs a user's context to determine
      // the user's rights and give them their settings
      if (!currentContext || currentContext === 'pre') {
        const [context] = Object.keys(meta.context) || []
        setKey(context, G.CONTEXT, sessionState)
      }

      await obj[G.ADAPTER][G.SETTINGS][G.API].init({
        detail: { [G.DATA]: { [G.API]: { type: 'userSettings', version: 1 }, settings: userSettings } },
      })

      setKey(currentContext, G.CONTEXT, sessionState)

      console.log('User settings initialized')
    } catch (e) {
      console.error(`Could not initialize user settings: ${e}`)
    }
  }

  return args
}

export default init
